<template>
    <div class="d-flex col-sm justify-content-center">
        <div class="container">
            <div class="row">
               <v-col  class="text-center">
                   <h1>Extrémovo Udělátka</h1>
                   <p>Zde najdeš věci co se můžou někdy hodit, pokud jsi hráč PokemonGO nebo si užíváš šifrování.</p>
               </v-col>
            </div>
            <div class="row">
                <div class="col-md-3"><!-- col-xl-2 -->
                    <b-nav vertical>
                        <b-nav-item class="p-1" to="/pokemon">
                          Počítadlo PoGo Statů
<!--                          <router-link to="/pokemon">Počítadlo PoGo Statů</router-link>-->
                        </b-nav-item>
                        <b-nav-item class="p-1" @click="showCyphers=!showCyphers"><router-link to="/cypher">Šifrovátko</router-link>&nbsp;
                            <b-badge  @click="showCyphers=!showCyphers"><b v-if="!showCyphers" > + </b><b v-if="showCyphers"> - </b></b-badge>
                            <div v-if="showCyphers">
                                <b-nav vertical v-for="(cypher) in this.cyphers" :key="cypher.key">
                                    <b-nav-item class="ml-3" :to="cypherLink(cypher.key)">
                                      {{cypher.name}} <b-badge v-if="cypher.help" variant="secondary">?</b-badge>
<!--                                      <router-link class="" :to="cypherLink(cypher.key)">{{cypher.name}}</router-link> <b-badge v-if="cypher.help" variant="secondary">?</b-badge>-->
                                    </b-nav-item>
                                </b-nav>
                            </div>
                        </b-nav-item>
                    </b-nav>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-unused-vars

    import VCol from "./components/bootstrap/vCol";
    import { BBadge, BButton, BNav,BNavItem  } from 'bootstrap-vue'
    import {
        Cyphers,
    } from './components/cyphers/cyphers.js';
    export default {
        name: 'app',
        components: {
            VCol,
            BBadge,
            BNav,
            BNavItem
        },
        data:function () {
            const cyphhers =  Object.entries(Cyphers).map((a)=> {
                let e = {}
                e[a[0].toString()]=a[1].toString();
                e['key']=a[0].toString();
                e['name']=a[1].toString();
                e['help']=false;
                return e;
            });
            return {
                cyphers: cyphhers,
                showCyphers: false
            }
        },
        methods:{
            cypherLink: function (key) {
                return ("/cypher?cypher="+key)
            }
        }
    }
</script>

<style>

</style>
